import axios, { AxiosRequestConfig, AxiosResponse } from "axios";
import { URL_ENDPOINTS } from "../constants";
import { setupInterceptorsTo } from "./Interceptors";

export const axiosInstance = setupInterceptorsTo(
  axios.create({
    baseURL: URL_ENDPOINTS.BASE_URL,
    headers: {
      "Content-Type": "application/json",
    },
    withCredentials: false,
  })
);

export const Api = {
  GET: async (URL: string, params?: any) => {
    const options = {
      params,
    };
    const request = await axiosInstance.get(URL, options);

    return request;
  },
  POST: async (
    URL: string,
    data: any,
    config?: AxiosRequestConfig
  ): Promise<AxiosResponse<any>> => {
    const request = await axiosInstance.post(URL, data, config);
    return request;
  },
  PUT: async (URL: string, data: any): Promise<AxiosResponse<any>> => {
    const request = await axiosInstance.put(URL, data);

    return request;
  },
};

export default Api;